import { render, staticRenderFns } from "./Follow.vue?vue&type=template&id=caa5e6fa&scoped=true&"
import script from "./Follow.vue?vue&type=script&lang=ts&"
export * from "./Follow.vue?vue&type=script&lang=ts&"
import style0 from "./Follow.vue?vue&type=style&index=0&id=caa5e6fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa5e6fa",
  null
  
)

export default component.exports